import React from "react";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";
import { useOffline } from "@/contexts/OfflineContext";

export default function OfflineBanner() {
  const { isOnline, pending, syncing, triggerSync } = useOffline();

  if (isOnline && pending === 0) return null;

  if (!isOnline) {
    return (
      <div
        data-testid="offline-banner"
        className="sticky top-0 z-40 bg-amber-500/100 text-white px-4 py-2 text-sm flex items-center justify-center gap-2 shadow-sm"
      >
        <WifiOff className="w-4 h-4" />
        <span className="font-medium">Mode hors-ligne</span>
        {pending > 0 && (
          <span className="ml-2 bg-white/25 rounded-full px-2 py-0.5 text-xs font-semibold">
            {pending} en attente
          </span>
        )}
      </div>
    );
  }

  // Online but pending items: show sync bar
  return (
    <div
      data-testid="sync-banner"
      className="sticky top-0 z-40 bg-emerald-500/100 text-white px-4 py-2 text-sm flex items-center justify-center gap-2 shadow-sm"
    >
      {syncing ? (
        <>
          <RefreshCw className="w-4 h-4 animate-spin" />
          <span className="font-medium">Synchronisation en cours…</span>
        </>
      ) : (
        <>
          <CloudUpload className="w-4 h-4" />
          <span className="font-medium">{pending} modification{pending > 1 ? "s" : ""} à synchroniser</span>
          <button
            data-testid="sync-now-btn"
            onClick={triggerSync}
            className="ml-2 bg-white/25 hover:bg-white/35 rounded-full px-3 py-0.5 text-xs font-semibold transition-colors"
          >
            Synchroniser
          </button>
        </>
      )}
    </div>
  );
}
